module.exports = {"routes":{"main":"/","search":"/search","checkout":"/checkout","success":"/buy/success","error":"/buy/error"},"style":{"color":{"primary":"green","main":"#00b89c"},"font":{"family":"Merriweather"}},"api":{"ptoken":"","local":"/api","dev":"https://ims-preprod.blablacar.pro/api/widget","preprod":"https://ims-preprod.blablacar.pro/api/widget","prod":"https://ims.blablacar.pro/api/widget"},"lang":{"api":"uk"}}


//////////////////
// WEBPACK FOOTER
// ./script/config.json
// module id = bX1a
// module chunks = 1